import { WeightMetric } from '../../../../model/prefixed-unit/weight.metric';
import { unitFactors } from '../../../../functions/prefixed-unit/unit-factors';

/**
 * @param value in Tonnes
 * @returns
 */
export function getSuggestedUnit(value: number): WeightMetric {
  const absValue = Math.abs(value);

  if (absValue >= Math.pow(10, unitFactors.weightMetricGigaTonne)) {
    return WeightMetric.GigaTonne;
  }
  if (absValue >= Math.pow(10, unitFactors.weightMetricMegaTonne)) {
    return WeightMetric.MegaTonne;
  }
  if (absValue >= Math.pow(10, unitFactors.weightMetricKiloTonne)) {
    return WeightMetric.KiloTonne;
  }
  if (absValue >= Math.pow(10, unitFactors.weightMetricTonne)) {
    return WeightMetric.Tonne;
  }
  if (absValue >= Math.pow(10, unitFactors.weightMetricKiloGram)) {
    return WeightMetric.KiloGram;
  }

  return WeightMetric.Gram;
}
